export default "__VITE_ASSET__a3YP5SJW__"